export const RYDE_STRING = 'ryde';
export const HR_STRING = 'rental';
export const CITY_HR = 'City_HR';
export const ROUTE_CARTYPE = 'Route_CarType';

export const isomorphicDateBarDateFormat = 'ddd, DD MMM';

export const selectedFilterBaseImage =
  '//jsak.mmtcdn.com/cabs_cdn_dt/ba23dd050727d34a14c3.png';

export const CLEAR_ALL_TEXT = 'CLEAR ALL';
export const SELECT_FILTER_TEXT = `Select Filters`;
export const BOOK = 'Book';
export const BOOK_NOW = 'BOOK NOW';
export const MYSAFETY_IMAGE =
  'https://jsak.mmtcdn.com/cabs_cdn_dt/af6f846ec83b5d287aad.png';
export const NEW = 'New';
export const NO_RATINGS = 'No ratings';
export const VIEW_PRICES = 'VIEW PRICES';
export const HIDE_PRICES = 'HIDE PRICES';
export const ORDER_FIELD = 'order';
export const WHY_BOOK_WITH_US_TEXT = 'Why book with us ?';
export const PRICE_SORT_ACSENDING_TEXT = 'Lowest to Highest';
export const RATING_SORT_DESCENDING_TEXT = 'Highest to Lowest';
export const ORDER_BY_PRICE_ASC = 'ORDER_BY_PRICE_ASC';
export const ORDER_BY_RATING_DESC = 'ORDER_BY_PRICE_DESC';
export const SCROLL = 'scroll';
export const TEMPO_TRAVELLER = 'tempo traveller';
export const MINIBUS = 'mini bus';
export const PACKAGE_PAGE_TYPE = 'PACKAGES';
